import { createConfig, http } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import { injectedWallet, bybitWallet, okxWallet, metaMaskWallet, walletConnectWallet } from '@rainbow-me/rainbowkit/wallets';
import binanceWallet from '@binance/w3w-rainbow-connector-v2'

// 自定义 BSC RPC 地址
// 方式1: 通过环境变量配置 (推荐用于生产环境)
// 在 .env 文件中设置: REACT_APP_BSC_RPC_URL=https://your-custom-rpc-url.com
const BSC_RPC_URL = process.env.REACT_APP_BSC_RPC_URL || 'https://rpc.48.club';

// 创建 wagmi 配置
export const config = createConfig({
  chains: [bsc], // 只包含 BSC 链
  transports: {
    [bsc.id]: http(BSC_RPC_URL)
  },
  connectors: connectorsForWallets([{
    groupName: 'Recommended',
    wallets: [injectedWallet, metaMaskWallet, binanceWallet, bybitWallet, okxWallet, walletConnectWallet],
  }], {
    appName: 'My RainbowKit App',
    projectId: '48club',
  }),
});
